const initalState = {
  printData: [],
  selected: [],
}
export const printReducer = (state = initalState, action) => {
  switch (action.type) {
    case 'FETCH_PRINT_DATA':
      return {
        ...state,
        selected: [],
        printData: action.payload,
      }
    case 'FETCH_PRINT_SELECTED':
      return {
        ...state,
        selected: action.payload,
      }
    default:
      return state
  }
}
